import React, { useState } from "react";
import "./contact.scss";
import axios from "axios";
import contact from "../../img/contact.jpg";
import {
  FaLocationDot,
  FaPhone,
  FaClock,
  FaLinkedin,
  FaGlobe,
} from "react-icons/fa6";
import { IoMail } from "react-icons/io5";

const Contact = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [success, setSuccess] = useState("");
  const [message, setMessage] = useState("");

  const sendMail = async (e) => {
    e.preventDefault();
    const data = { name, email, phone, message };
    try {
      const response = await axios.post("/send-mail", data);
      setSuccess(response.data);
      setName("");
      setEmail("");
      setPhone("");
      setMessage("");

      setTimeout(() => {
        setSuccess("");
      }, 4000);
    } catch (error) {
      console.error("Mail error", error);
    }
  };

  return (
    <div className="__fw">
      <div
        className="contact_head"
        style={{
          backgroundImage: `url(${contact})`,
          backgroundPosition: "center",
          backgroundSize: "cover",
        }}
      >
        <div className="cn_in">
          <h2>
            Contact <em>us</em>
          </h2>
        </div>
      </div>
      <div className="__mw">
        <div className="con_wrp">
          <div className="contact">
            <div className="form_in">
              {/* Form Section */}
              <div className="fm_right">
                <h4>
                  Enquiry <em>or Demo</em>
                </h4>
                <p>
                  Please fill out the form to submit your enquiry or to request
                  a demo
                </p>
                <form className="suggestion" onSubmit={sendMail}>
                  <div className="f_tp">
                    <div className="f_in">
                      <p>
                        Your Name <em>*</em>
                      </p>
                      <input
                        type="text"
                        required
                        placeholder="John Doe"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                      />
                    </div>
                    <div className="f_in">
                      <p>
                        Your Email <em>*</em>
                      </p>
                      <input
                        type="email"
                        value={email}
                        required
                        placeholder="you@example.com"
                        onChange={(e) => setEmail(e.target.value)}
                      />
                    </div>
                    <div className="f_in">
                      <p>
                        Phone <em>*</em>
                      </p>
                      <input
                        type="text"
                        required
                        placeholder="+971 XX XXX XXXX"
                        value={phone}
                        onChange={(e) => setPhone(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className="ft_text">
                    <p>
                      Message <em>*</em>
                    </p>
                    <textarea
                      rows={6}
                      value={message}
                      onChange={(e) => setMessage(e.target.value)}
                      placeholder="How can we help you?"
                      required
                    ></textarea>
                  </div>
                  <div className="con_btn_wrp">
                    <button type="submit">Submit Request</button>
                  </div>
                  {success && (
                    <p style={{ color: "#88E788", marginTop: "10px" }}>
                      Thank you! Your enquiry has been received.
                    </p>
                  )}
                </form>
              </div>

              {/* Enhanced Contact Details Section */}
              <div className="fm_lft">
                <h4>
                  Elite <em>Support</em>
                </h4>

                <div className="con_details">
                  {/* Headquarters */}
                  <div className="con_in">
                    <FaLocationDot color="#ffa500" size={22} />
                    <div>
                      <strong>Global Headquarters</strong>
                      <p>Intellitech LTD, Dubai, UAE</p>
                    </div>
                  </div>

                  {/* Email */}
                  <div className="con_in">
                    <IoMail color="#ffa500" size={22} />
                    <div>
                      <strong>Inquiries & Support</strong>
                      <p>support@intellitech.ae</p>
                    </div>
                  </div>

                  {/* 24/7 Status */}
                  <div className="con_in">
                    <FaClock color="#ffa500" size={22} />
                    <div>
                      <strong>
                        Service Status:{" "}
                        <span style={{ color: "#88E788" }}>Active</span>
                      </strong>
                      <p>24/7 Global Surveillance & Scanning</p>
                    </div>
                  </div>

                  <hr
                    style={{ border: "0.5px solid #eee", margin: "20px 0" }}
                  />

                  {/* Hybrid Execution Highlights */}
                  <div className="execution_highlights">
                    <h5
                      style={{
                        color: "#ffa500",
                        marginBottom: "10px",
                        fontSize: "1.1rem",
                      }}
                    >
                      Hybrid Execution
                    </h5>

                    <div
                      className="highlight_item"
                      style={{ marginBottom: "15px" }}
                    >
                      <strong>Elite Growth</strong>
                      <p style={{ fontSize: "0.9rem", color: "#666" }}>
                        Combining manual expertise with advanced AI trading
                        systems to optimize portfolio performance.
                      </p>
                    </div>

                    <div className="highlight_item">
                      <ul
                        style={{
                          listStyle: "none",
                          padding: 0,
                          fontSize: "0.85rem",
                          color: "#555",
                        }}
                      >
                        <li style={{ marginBottom: "8px" }}>
                          ⚡ <strong>Speed:</strong> Millisecond AI processing.
                        </li>
                        <li style={{ marginBottom: "8px" }}>
                          🤖 <strong>Consistency:</strong> Zero emotional bias.
                        </li>
                        <li style={{ marginBottom: "8px" }}>
                          🛡️ <strong>Risk Control:</strong> Hard-coded capital
                          protection.
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
